module.exports = __webpack_public_path__ + "static/img-subfooter-educators-c5a06ed37ef2b08e7d0c08d99475f5e9.jpg";